import { render, staticRenderFns } from "./InformesView.vue?vue&type=template&id=3deb15c0&"
import script from "./InformesView.vue?vue&type=script&lang=ts&"
export * from "./InformesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports